import { render, staticRenderFns } from "./LabelInputField.vue?vue&type=template&id=13122028&scoped=true&"
import script from "./LabelInputField.vue?vue&type=script&lang=js&"
export * from "./LabelInputField.vue?vue&type=script&lang=js&"
import style0 from "./LabelInputField.vue?vue&type=style&index=0&id=13122028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13122028",
  null
  
)

export default component.exports